/**
 * 7XXXXXXXXXX or null: the rule of crm-api (crm/api/src/phone.ts) and of the
 * database (vv_phone_norm). Used by the demo data provider and for tel: links.
 */
export const normalizePhone = (s: string | null | undefined): string | null => {
  if (typeof s !== "string") return null;
  const d = s.replace(/[^0-9]/g, "");
  if (/^7[0-9]{10}$/.test(d)) return d;
  if (/^8[0-9]{10}$/.test(d)) return `7${d.slice(1)}`;
  if (/^9[0-9]{9}$/.test(d)) return `7${d}`;
  return null;
};
